import { DOMAIN_VALUES, useGetDomainValue } from "@/service/orion";

import { domainValueToPowerBIDashbord } from "../adapters/domainValueToPowerBIDashbord";

export const useGetPowerBiDashboards = () => {
  const { data, ...query } = useGetDomainValue(
    ["powerBiDashboards"],
    DOMAIN_VALUES.powerBiDashboards,
  );

  try {
    const dashboards = data?.map(domainValueToPowerBIDashbord) ?? [];

    return { data: dashboards, ...query };
  } catch (error) {
    return { data: [], ...query, error: "No se pudieron obtener los dashboards" };
  }
};
